/* DailyLama — fiche « Bracelet à vœu » (V3).
 * Galerie, sélecteur de diamètre (haut et comparatif synchronisés), ajout au
 * panier par l'API Ajax de Shopify, barre collante des petits écrans, lecteur
 * du film. Tout est délégué à la racine [data-dlbv] : aucun écouteur global
 * hormis Échap pour la modale. */
(function () {
  'use strict';

  function lire(racine) {
    var el = racine.querySelector('[data-dlbv-variantes]');
    try { return JSON.parse(el ? el.textContent : '[]'); } catch (e) { return []; }
  }

  function galerie(racine) {
    var vues = [].slice.call(racine.querySelectorAll('[data-dlbv-vue]'));
    if (vues.length < 2) return;
    var vignettes = [].slice.call(racine.querySelectorAll('[data-dlbv-vignette]'));
    var compteur = racine.querySelector('[data-dlbv-compteur]');
    // La vue visible au chargement est décidée côté serveur (variante de l'URL).
    var courant = 0;
    for (var q = 0; q < vues.length; q++) { if (!vues[q].hidden) { courant = q; break; } }

    function montrer(i) {
      courant = (i + vues.length) % vues.length;
      vues.forEach(function (img, k) {
        img.hidden = k !== courant;
        if (k === courant && img.getAttribute('loading') === 'lazy') img.removeAttribute('loading');
      });
      vignettes.forEach(function (b, k) { b.setAttribute('aria-selected', k === courant ? 'true' : 'false'); });
      if (compteur) compteur.textContent = (courant + 1) + ' / ' + vues.length;
      var v = vignettes[courant];
      if (v && v.scrollIntoView && racine.offsetWidth < 768) {
        try { v.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); } catch (e) { /* ancien navigateur */ }
      }
    }
    vignettes.forEach(function (b, k) { b.addEventListener('click', function () { montrer(k); }); });
    var prec = racine.querySelector('[data-dlbv-prec]');
    var suiv = racine.querySelector('[data-dlbv-suiv]');
    if (prec) prec.addEventListener('click', function () { montrer(courant - 1); });
    if (suiv) suiv.addEventListener('click', function () { montrer(courant + 1); });

    // Média lié à une variante (image_id Shopify) : la sélection d'un diamètre
    // affiche la photo de ce diamètre, depuis le sélecteur comme depuis le comparatif.
    racine._dlbvMontrerImage = function (imageId) {
      if (!imageId) return;
      for (var k = 0; k < vues.length; k++) {
        if (String(vues[k].getAttribute('data-dlbv-image-id')) === String(imageId)) { montrer(k); return; }
      }
    };

    // Balayage tactile sur la grande photo.
    var cadre = racine.querySelector('[data-dlbv-cadre]');
    var x0 = null;
    if (cadre) {
      cadre.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      cadre.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) montrer(dx < 0 ? courant + 1 : courant - 1);
      }, { passive: true });
    }
  }

  function selection(racine, variantes) {
    var id = parseInt(racine.getAttribute('data-choisi'), 10);
    var courante = variantes.filter(function (v) { return v.id === id; })[0] || variantes[0];
    var boutons = [].slice.call(racine.querySelectorAll('[data-dlbv-taille]'));
    var rendus = [].slice.call(racine.querySelectorAll('[data-dlbv-rendu]'));
    var prix = racine.querySelector('[data-dlbv-prix]');
    var meta = racine.querySelector('[data-dlbv-prix-meta]');
    var epuise = racine.querySelector('[data-dlbv-epuise]');
    var epuiseTexte = racine.querySelector('[data-dlbv-epuise-texte]');
    var ctas = [].slice.call(racine.querySelectorAll('[data-dlbv-ajouter]'));
    var libelle = racine.querySelector('[data-dlbv-cta-libelle]');
    var panierVariante = racine.querySelector('[data-dlbv-panier-variante]');
    var panierPrix = racine.querySelector('[data-dlbv-panier-prix]');
    var collTaille = racine.querySelector('[data-dlbv-collante-taille]');
    var collPrix = racine.querySelector('[data-dlbv-collante-prix]');
    var produitDispo = variantes.some(function (v) { return v.dispo; });

    function appliquer(v, utilisateur) {
      courante = v;
      racine.setAttribute('data-choisi', v.id);
      boutons.forEach(function (b) { b.setAttribute('aria-checked', parseInt(b.getAttribute('data-dlbv-taille'), 10) === v.id ? 'true' : 'false'); });
      rendus.forEach(function (b) {
        var on = parseInt(b.getAttribute('data-dlbv-rendu'), 10) === v.id;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var etat = b.querySelector('[data-dlbv-rendu-etat]');
        if (etat && !b.disabled) etat.textContent = on ? 'Sélectionné' : 'Choisir ce diamètre';
      });
      if (prix) prix.textContent = v.prix;
      var prefixe = v.mm ? 'Diamètre ' : '';
      if (meta) meta.textContent = v.label ? (v.label + (v.qual ? ' · ' + v.qual : '')) : '';
      if (panierVariante) panierVariante.textContent = v.label ? prefixe + v.label : '';
      if (panierPrix) panierPrix.textContent = v.prix;
      if (collTaille) collTaille.textContent = v.label ? prefixe + v.label : '';
      if (collPrix) collPrix.textContent = v.prix;

      var ok = produitDispo && v.dispo;
      if (epuise) {
        epuise.hidden = !(produitDispo && !v.dispo);
        if (epuiseTexte) {
          var autres = variantes.filter(function (x) { return x.dispo && x.id !== v.id; }).map(function (x) { return x.label; });
          var mot = v.mm ? 'diamètres' : 'options';
          epuiseTexte.textContent = autres.length ? 'Les autres ' + mot + ' restent disponibles : ' + autres.join(' et ') + '.' : 'Aucune autre option n’est disponible pour le moment.';
        }
      }
      ctas.forEach(function (c) { c.disabled = !ok; });
      if (libelle) libelle.textContent = !produitDispo ? 'Produit indisponible' : !v.dispo ? (v.mm ? 'Choisissez un autre diamètre' : 'Choisissez une autre option') : 'Ajouter au panier';
      fermerPanier(racine);
      if (utilisateur && racine._dlbvMontrerImage) racine._dlbvMontrerImage(v.image);
      // L'URL suit la sélection, sans rechargement ni entrée d'historique.
      try {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) { /* URL indisponible */ }
    }

    function brancher(liste, attr) {
      liste.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          var vid = parseInt(b.getAttribute(attr), 10);
          var v = variantes.filter(function (x) { return x.id === vid; })[0];
          if (v) appliquer(v, true);
          if (attr === 'data-dlbv-rendu') {
            var cible = racine.querySelector('[data-dlbv-taille="' + vid + '"]');
            if (cible) cible.focus({ preventScroll: true });
          }
        });
      });
    }
    brancher(boutons, 'data-dlbv-taille');
    brancher(rendus, 'data-dlbv-rendu');

    // Flèches dans le groupe radio.
    boutons.forEach(function (b, k) {
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = boutons.length, j = k;
        for (var t = 0; t < n; t++) { j = (j + d + n) % n; if (!boutons[j].disabled) break; }
        boutons[j].focus(); boutons[j].click();
      });
    });

    return function () { return courante; };
  }

  function fermerPanier(racine) {
    var carte = racine.querySelector('[data-dlbv-panier]');
    if (carte) carte.hidden = true;
  }

  function panier(racine, courante) {
    var ctas = [].slice.call(racine.querySelectorAll('[data-dlbv-ajouter]'));
    var principal = ctas[0];
    var spin = racine.querySelector('.dlbv-cta__spin');
    var libelle = racine.querySelector('[data-dlbv-cta-libelle]');
    var erreur = racine.querySelector('[data-dlbv-erreur]');
    var carte = racine.querySelector('[data-dlbv-panier]');
    var fermer = racine.querySelector('[data-dlbv-panier-fermer]');
    var reessayer = racine.querySelector('[data-dlbv-reessayer]');
    var url = racine.getAttribute('data-cart-add') || '/cart/add';
    var root = racine.getAttribute('data-root') || '/';
    var enCours = false;

    function occupe(oui) {
      enCours = oui;
      ctas.forEach(function (c) { c.setAttribute('aria-busy', oui ? 'true' : 'false'); });
      if (spin) spin.hidden = !oui;
      if (libelle) libelle.textContent = oui ? 'Ajout en cours…' : 'Ajouter au panier';
    }

    // Le thème (Dawn) porte sa pastille de compteur dans #cart-icon-bubble ;
    // l'API la rend à jour en une passe avec l'ajout.
    function majBulle(sections) {
      var html = sections && sections['cart-icon-bubble'];
      var bulle = document.getElementById('cart-icon-bubble');
      if (!html || !bulle) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var neuf = doc.getElementById('shopify-section-cart-icon-bubble') || doc.body;
      bulle.innerHTML = neuf.innerHTML;
    }

    function ajouter() {
      if (enCours) return;
      var v = courante();
      if (!v || !v.dispo) return;
      if (erreur) erreur.hidden = true;
      occupe(true);
      var corps = { items: [{ id: v.id, quantity: 1 }], sections: 'cart-icon-bubble', sections_url: window.location.pathname };
      fetch(url + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(corps)
      }).then(function (r) {
        if (!r.ok) throw new Error('panier ' + r.status);
        return r.json();
      }).then(function (rep) {
        occupe(false);
        majBulle(rep && rep.sections);
        if (carte) { carte.hidden = false; }
        try { document.dispatchEvent(new CustomEvent('dlbv:ajout', { detail: { variant: v.id } })); } catch (e) { /* CustomEvent absent */ }
        if (principal && racine.offsetWidth < 768) {
          try { carte.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e2) { /* ancien navigateur */ }
        }
      }).catch(function () {
        occupe(false);
        if (erreur) { erreur.hidden = false; }
      });
    }

    ctas.forEach(function (c) { c.addEventListener('click', ajouter); });
    if (reessayer) reessayer.addEventListener('click', ajouter);
    if (fermer) fermer.addEventListener('click', function () { if (carte) carte.hidden = true; if (principal) principal.focus(); });
  }

  // Barre collante : visible sur petit écran quand le bouton principal a quitté
  // l'écran par le haut, jamais quand il est visible. Mesure au défilement et
  // non par IntersectionObserver : un saut direct au-delà du bouton (ancre,
  // restauration de position) ne franchit aucun seuil et ne déclencherait rien.
  function collante(racine) {
    var barre = racine.querySelector('[data-dlbv-collante]');
    var principal = racine.querySelector('.dlbv-cta');
    if (!barre || !principal) return;
    barre.hidden = false;
    var prevu = false;
    function maj() {
      prevu = false;
      var passe = principal.getBoundingClientRect().bottom < 0;
      barre.setAttribute('data-visible', passe ? '1' : '0');
      racine.setAttribute('data-collante', passe ? '1' : '0');
    }
    function demande() {
      if (prevu) return;
      prevu = true;
      (window.requestAnimationFrame || window.setTimeout)(maj);
    }
    window.addEventListener('scroll', demande, { passive: true });
    window.addEventListener('resize', demande);
    maj();
  }

  function film(racine) {
    var voile = racine.querySelector('[data-dlbv-voile]');
    if (!voile) return;
    var video = voile.querySelector('[data-dlbv-video]');
    var retour = null;
    function ouvrir(e) {
      retour = e && e.currentTarget;
      voile.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var f = voile.querySelector('[data-dlbv-film-fermer]');
      if (f) f.focus();
    }
    function fermer() {
      if (voile.hidden) return;
      voile.hidden = true;
      document.documentElement.style.overflow = '';
      if (video) { try { video.pause(); } catch (e) { /* rien */ } }
      if (retour && retour.focus) retour.focus();
    }
    [].slice.call(racine.querySelectorAll('[data-dlbv-film-ouvrir]')).forEach(function (b) { b.addEventListener('click', ouvrir); });
    var f = voile.querySelector('[data-dlbv-film-fermer]');
    if (f) f.addEventListener('click', fermer);
    voile.addEventListener('click', function (e) { if (e.target === voile) fermer(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(); });
  }

  function monter(racine) {
    if (racine.getAttribute('data-dlbv-monte') === '1') return;
    racine.setAttribute('data-dlbv-monte', '1');
    var variantes = lire(racine);
    galerie(racine);
    var courante = selection(racine, variantes);
    panier(racine, courante);
    collante(racine);
    film(racine);
  }

  function demarrer() {
    [].slice.call(document.querySelectorAll('[data-dlbv]')).forEach(monter);
  }

  if (typeof document === 'undefined') return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
  document.addEventListener('shopify:section:load', demarrer);
})();
